import superagent from "superagent";
import { normalize, schema } from "normalizr";
import { apiGet, baseUrl } from "./helpers/api";
import RailsMiddleWare from "./helpers/railsMiddleware";
import UnauthorizedMiddleware from "./helpers/unauthorizedMiddleware";
import { saveFile } from "./helpers/saveFile";

const certificateCourses = new schema.Object("certificateCourses");
const certificateLessons = new schema.Object("certificateLessons");

export const fetchCertificateCourses = (userId, dispatch) => {
  dispatch({ type: "CERTIFICATE_COURSES_FETCH_REQUESTED" });
  return apiGet(`/api/v1/users/${userId}/course_certificates`).then(
    (response) => {
      dispatch({
        type: "CERTIFICATE_COURSES_FETCHED",
        ...normalize(response.body, certificateCourses),
      });
    }
  );
};

export const fetchCertificateLessons = (userId, dispatch) => {
  dispatch({ type: "CERTIFICATE_LESSONS_FETCH_REQUESTED" });
  return apiGet(`/api/v1/users/${userId}/lesson_certificates`).then(
    (response) => {
      dispatch({
        type: "CERTIFICATE_LESSONS_FETCHED",
        ...normalize(response.body, certificateLessons),
      });
    }
  );
};

export const downloadCertificate = async (url) => {
  return await superagent
    .get(`${baseUrl}${url}`)
    .use(RailsMiddleWare)
    .use(UnauthorizedMiddleware)
    .responseType("blob")
    .then((res) => {
      saveFile(res.body, "certificado", "pdf");
    })
    .catch((err) => {
      console.error("Download failed:", err);
    });
};
